import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=38c879ad&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=ts&"
export * from "./BarChart.vue?vue&type=script&lang=ts&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=38c879ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c879ad",
  null
  
)

export default component.exports